<template>
  <nav class="main-menu">
    <ul v-if="menu">
      <li v-for="(item, index) in menu.items" v-bind:key="index">
        <router-link :to="'/'+slug(item.url)">
          <component :is="item.classes[0]"></component>
          <div>{{item.title}}</div>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { settings } from '../variables.js'

export default {
  data () {
    return {}
  },
  created: function () {},
  methods: {
    slug (str) {
      return str.toString().replace(settings.baseUrl, '').replace('/', '')
    }
  },
  computed: {
    menu () {
      return this.$store.state.menu
    }
  }
}
</script>

<style lang="scss">
  nav.main-menu {
    background-color: #fff;
    z-index: 10;
    grid-row: 4;
    position: fixed;
    bottom: 0;
    width: 100%;

    ul {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      // flex-wrap: wrap;
      // justify-content: space-between;
      list-style: none;
      max-width: 1024px;
      width: 100%;
      margin: 0 auto;
      padding-left: 0;

      li {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        line-height: 2em;
      }

      a {
        // font-weight: bold;
        text-decoration: none;
        color: #2c3e50;
        padding: 15px 5px;

        &:hover {
          color: #86ff00;
        }
        &.router-link-exact-active {
          color: #5c47a7;
          cursor: default;
        }
        span {
          font-size: 32px;
        }
        div {
          display: none;
        }

        @media all and (min-width: 768px) {
          padding: 5px;

          div {
            display: block;
          }
          span {
            font-size: 22px;
          }
        }
      }
    }

    @media all and (min-width: 768px) {
      position: sticky;
      top: 0;
      grid-row: 2;
    }
  }
</style>
